export default "__VITE_ASSET__CnN0oWJF__"